import { useNavigate } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger } from "../ui/tabs";
import { useAudit } from "../../contexts/auditContext";
import { sessionRouteBase } from "../../lib/sessionApiBase";

interface AuditSessionTabsProps {
  activeTab: "support" | "documents" | "workpaper" | "workpaper-v2";
  v2?: boolean;
}

export const AuditSessionTabs = ({
  activeTab,
  v2 = false,
}: AuditSessionTabsProps) => {
  const navigate = useNavigate();
  const { controlSession, setCurrentSelection, sessionKind } = useAudit();
  const sessionBasePath = sessionRouteBase(sessionKind);
  return (
    <Tabs value={activeTab}>
      <TabsList>
        <TabsTrigger
          value="support"
          onClick={() => {
            navigate(`${sessionBasePath}/${controlSession?.id}/`);
          }}
        >
          Support
        </TabsTrigger>
        <TabsTrigger
          value="documents"
          onClick={() => {
            navigate(`${sessionBasePath}/${controlSession?.id}/documents`);
          }}
        >
          Documents
        </TabsTrigger>
        <TabsTrigger
          value="workpaper"
          onClick={() => {
            // Clear any open cell selection so clicking Workpaper — even when
            // already on it — collapses any fold-out back to just the table,
            // matching a fresh navigation to the tab.
            setCurrentSelection(undefined);
            navigate(`${sessionBasePath}/${controlSession?.id}/workpaper-view`);
          }}
        >
          Workpaper
        </TabsTrigger>
        {v2 && (
          <TabsTrigger
            value="workpaper-v2"
            onClick={() => {
              navigate(`${sessionBasePath}/${controlSession?.id}/workpaper-v2`);
            }}
          >
            Workpaper Export
          </TabsTrigger>
        )}
      </TabsList>
    </Tabs>
  );
};
